module.exports = __webpack_public_path__ + "static/media/kangyang-1@2x.e6086a60.png";